import React, { forwardRef, useCallback, useContext } from 'react';

import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Grid as AntGrid } from 'antd';

import { MyTableContext } from '..';

export interface IMyTableHeaderIndex {
  title?: string;
  callback?: (index: number) => void;
  numeric?: boolean;
  ordering?: boolean | 'asc' | 'desc';
  el?: JSX.Element;
}

interface IProps {
  index?: IMyTableHeaderIndex[];
  ordering?: boolean | 'asc' | 'desc';
  ordered?: number;
  responsive?: boolean;
  classes?: any;
  disableResponsive?: boolean;
  onChangeOrder?: (item: IMyTableHeaderIndex, index: number) => void;
}

const MyTableHeader = forwardRef<any, IProps>(
  ({ index: headerIndex, ordering, ordered, disableResponsive, onChangeOrder }, ref) => {
    const { responsive } = useContext(MyTableContext);
    const screens = AntGrid.useBreakpoint();
    const isDesktop = !!screens.md;

    const handleChangeOrder = useCallback(
      (item: IMyTableHeaderIndex, idx: number) => {
        return () => {
          if (item.callback) {
            item.callback(idx);
          }

          if (onChangeOrder) {
            onChangeOrder(item, idx);
          }
        };
      },
      [onChangeOrder]
    );

    if (!responsive || isDesktop || disableResponsive) {
      return (
        <thead ref={ref}>
          <tr>
            {headerIndex &&
              headerIndex.map((item, idx) => (
                <th
                  key={`index-${idx}`}
                  className={
                    'p-2 text-left first:pl-4' + (item.numeric ? 'numeric' : '') + (item.ordering ? ' ordering' : '')
                  }
                  onClick={handleChangeOrder(item, idx)}
                >
                  {item.title ? item.title : item.el}

                  {ordering && ordered === idx ? (
                    <span style={{ marginLeft: 4, fontSize: 14, position: 'relative', top: 1 }}>
                      {ordering === 'asc' ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                    </span>
                  ) : (
                    ''
                  )}
                </th>
              ))}
          </tr>
        </thead>
      );
    }

    return <div ref={ref}></div>;
  }
);

export default MyTableHeader;
